module.exports = __webpack_public_path__ + "prod/1.42.2/img/new_content_one.42b6c653.png";